// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import { useLocation } from 'react-router-dom';
import { useTranslation, Trans as T } from 'react-i18next';
import { Link } from '../link.tsx';
import { Products_menu } from './products_menu.js';
import { Sites_menu } from './sites_menu.js';
import { Plus_menu } from './plus_menu.js';
var Links_nav = props => {
  useTranslation();
  var links = props.links,
    menu_toggle = props.menu_toggle;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var menu_ref = useRef();
  var _useRef = useRef({
      sites: useRef(),
      products: useRef(),
      plus: useRef()
    }),
    r = _useRef.current;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    h = _useState2[0],
    set_h = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    opened = _useState4[0],
    set_opened = _useState4[1];
  var menu_open = menu => () => {
    set_opened(menu);
    menu_toggle(true);
  };
  var menu_close = () => {
    set_opened(null);
    menu_toggle(false);
  };
  var products_cls = cn('nav-tab dropdown products', pathname == '/products' && 'nav-tab-active');
  var on_menu_click = () => () => {
    console.log('do nothing');
  };
  useEffect(menu_close, [pathname]);
  useEffect(() => {
    if (!opened) return void set_h(0);
    setTimeout(() => {
      set_h(r[opened].current.getBoundingClientRect().height);
    }, 0);
  }, [opened]);
  return /*#__PURE__*/React.createElement("div", {
    className: "links_nav_wrapper",
    ref: menu_ref,
    onMouseLeave: menu_close
  }, /*#__PURE__*/React.createElement("ul", {
    className: "links_nav_container"
  }, opened && /*#__PURE__*/React.createElement("div", {
    className: "nav_veil"
  }), /*#__PURE__*/React.createElement("li", {
    className: links.sites.cls,
    onMouseEnter: menu_open('sites')
  }, /*#__PURE__*/React.createElement(Link, {
    className: "nav-link",
    to: links.sites.to,
    onClick: on_menu_click('navbar_sites')
  }, /*#__PURE__*/React.createElement(T, null, links.sites.text))), /*#__PURE__*/React.createElement("li", {
    className: products_cls,
    onMouseEnter: menu_open('products')
  }, /*#__PURE__*/React.createElement(Link, {
    className: "nav-link dropdown-toggle",
    to: links.products.to,
    onClick: on_menu_click('navbar_products')
  }, /*#__PURE__*/React.createElement(T, null, links.products.text))), links.plus.show && /*#__PURE__*/React.createElement("li", {
    onMouseEnter: menu_open('plus')
  }, /*#__PURE__*/React.createElement(Link, {
    className: links.plus.cls,
    to: links.plus.to,
    onClick: on_menu_click('navbar_plans')
  }, /*#__PURE__*/React.createElement(T, null, links.plus.text)))), /*#__PURE__*/React.createElement("div", {
    className: cn('links_nav_menu', opened && 'shown'),
    style: {
      height: `${h}px`
    }
  }, /*#__PURE__*/React.createElement(Sites_menu, _extends({}, props, {
    opened: opened == 'sites',
    ref: r.sites
  })), /*#__PURE__*/React.createElement(Products_menu, {
    opened: opened == 'products',
    ref: r.products
  }), /*#__PURE__*/React.createElement(Plus_menu, _extends({}, props, {
    opened: opened == 'plus',
    ref: r.plus
  }))));
};
export { Links_nav };